import { useEffect, useState, FC, JSX } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { isValidIdCase } from "shared/utils/hooks/useValidationIdCase";

interface IValidatedRoute {
  component?: JSX.Element;
}

export const ValidatedRoute: FC<IValidatedRoute> = ({ component }) => {
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const idCase = queryParams.get('id');

    if (idCase) {
      if (isValidIdCase(idCase)) {
        setIsValid(true);
      } else {
        console.error('Invalid idCase');
        navigate('/404');
      }
    } else {
      setIsValid(true);
    }
  }, [location, navigate]);

  return isValid ? component : null;
};
